import { http } from './api'

const resource = 'fila-acesso'

export default {
    quantidadeEfetivacoes1Cargo: (dados) => {
        return http.get(`fila-acesso/quantidade-efetivacoes-1cargo`, {params: dados})
    },
    
    quantidadeEfetivacoesPEB: (dados) => {
        return http.get(`fila-acesso/quantidade-efetivacoes-peb`, {params: dados})
    },

    quantidadeEfetivacoesExtensaoCargaHoraria: (dados) => {
        return http.get(`fila-acesso/quantidade-efetivacoes-extensao-carga-horaria`, {params: dados})
    },

    obterEfetivacoesPorCargo: (dados) => {
        return http.get(`fila-acesso/efetivacoes-por-cargo`, {params: dados})
    },
    // obterRanking: (aaletivo, aatcargo, mmtcargo, cdgcargo, cdcargo, tpcargo, cdespecia, datas ) => {
    //     return http.get(`${resource}/gerar-ranking/${aaletivo}/${aatcargo}/${mmtcargo}/${cdgcargo}/${cdcargo}/${tpcargo}/${cdespecia}/${datas}`)
    // },
    obterRanking: (dados) => {
        return http.post(`${resource}/gerar-ranking`, dados)
    },
    salvarRanking: (dados) => {
        return http.post(`${resource}/salvar-ranking`, dados)
    },
    excluirRanking: (dados) => {
        return http.post(`${resource}/excluir-ranking`, dados)
    },
    adiarRanking: (dados) => {
        return http.post(`${resource}/adiar-ranking`, dados)
    },
    cancelarEfetivacoesDoDia: (dados) => {
        return http.post(`${resource}/cancelar-efetivacoes`, dados)
    },

}